import React from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

const TimePicker = ({ value, onChange }) => {
  // Ensure value is valid; default to "12:00" if undefined
  const [hours, setHours] = React.useState(value?.split(":")[0] || "12");
  const [minutes, setMinutes] = React.useState(value?.split(":")[1] || "00");

  const handleTimeChange = () => {
    const time = `${hours}:${minutes}`;
    onChange(time); // Pass the updated time back to the parent
  };

  React.useEffect(() => {
    handleTimeChange();
  }, [hours, minutes]);

  // Add useEffect to sync with external value changes
  React.useEffect(() => {
    if (value) {
      const [newHours, newMinutes] = value.split(":");
      setHours(newHours || "12");
      setMinutes(newMinutes || "00");
    }
  }, [value]); // Add value to dependency array

  return (
    <div className="flex items-center gap-2">
      {/* Hours Dropdown */}
      <Select value={hours} onValueChange={(val) => setHours(val)}>
        <SelectTrigger className="w-fit h-8 border-background/20 text-background/90 data-[placeholder]:text-background/60 text-xs rounded-lg gap-1">
          <SelectValue placeholder="HH" className="placeholder:text-xs" />
        </SelectTrigger>
        <SelectContent className="text-xs rounded-md">
          {Array.from({ length: 24 }, (_, i) => i).map((hour) => (
            <SelectItem
              key={hour}
              value={String(hour).padStart(2, "0")}
              className="text-xs"
            >
              {String(hour).padStart(2, "0")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Minutes Dropdown */}
      <Select value={minutes} onValueChange={(val) => setMinutes(val)}>
        <SelectTrigger className="w-fit h-8 border-background/20 text-background/90 data-[placeholder]:text-background/60 text-xs rounded-lg gap-1">
          <SelectValue placeholder="MM" className="placeholder:text-xs" />
        </SelectTrigger>
        <SelectContent className="text-xs rounded-md">
          {Array.from({ length: 60 }, (_, i) => i).map((minute) => (
            <SelectItem
              key={minute}
              value={String(minute).padStart(2, "0")}
              className="text-xs"
            >
              {String(minute).padStart(2, "0")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TimePicker;
